import React from 'react';
import DataTable from '../../smart-kit/data-table/DataTable';
import { SimpleCard } from 'app/components';
import { apiPaths } from 'app/services/api';

const Agents = () => {
  const columns = [
    {
      name: 'Name',
      key: 'name',
    },
    { name: 'Mobile', key: 'mobile_number' },
    { name: 'Stores Count', key: 'stores_count' },
    { name: 'Warranties Count', key: 'warranties_count' },
    { name: 'Active Warranties', key: 'paid_warranties' },
    { name: 'Store Bonus', key: 'compensation.bonuses.storeBonus', type: 'price' },
    { name: 'Warranty Bonus', key: 'compensation.bonuses.warrantyBonus', type: 'price' },
    {
      name: 'Create Date',
      key: 'created_at',
      type: 'date',
      sort: true,
    },
  ];

  const filtersOn = [
    { name: 'Mobile', key: 'mobile_number' },
    { name: 'Name', key: 'name' },
  ];

  return (
    <div className="m-sm-30">
      <div className="mb-sm-30"></div>
      <div className="py-3" />
      <SimpleCard>
        <DataTable
          title="Agents"
          path="agents"
          apipath={apiPaths.AGENTS}
          columns={columns}
          filtersOn={filtersOn}
          hideActions={['delete', 'view']}
          showExport
          actions={[
            {
              key: 'create',
              auth: ['admin'],
            },
            {
              key: 'edit',
              auth: ['admin'],
            },
          ]}
        />
      </SimpleCard>
    </div>
  );
};

export default Agents;
